import { AppModal } from '@/components/app-modal'
import { ModalEnum } from '@/interfaces'
import { cancelAssistantPlan } from '@/services/assistant-plan.js'
import { useStores } from '@/stores/RootStoreContext'
import { Form, notification } from 'antd'
import { computed } from 'mobx'
import { observer } from 'mobx-react-lite'
import { useEffect, useState } from 'react'
import Footer from './footer'
import Header from './header'
import StepOne from './stepOne'
import StepThree from './stepThree'
import StepTwo from './stepTwo'

const modalStyles = {
  content: {
    borderRadius: 10,
    padding: '45px 42px 36px 42px',
  },
  body: {
    display: 'flex',
    flexDirection: 'column',
  },
}

const CancelPlanModal = observer(() => {
  const { modalStore } = useStores()

  const [form] = Form.useForm()
  const [loading, setLoading] = useState(false)

  const MODAL_ID = ModalEnum.CANCEL_PLAN

  // Possible steps: "reason", "password", "confirmation"
  const [step, setStep] = useState('reason')

  const modalIsOpen = computed(() => modalStore.modalIsOpen(MODAL_ID)).get()

  const onCancel = () => {
    modalStore.closeModal(MODAL_ID)
  }

  const onFinish = async () => {
    switch (step) {
      case 'reason':
        setStep('password')
        break
      case 'password':
        setLoading(true)
        try {
          const data = form.getFieldsValue(true)
          await cancelAssistantPlan(data)
          setStep('confirmation')
        } catch (err) {
          notification.error({
            message: 'Erro ao cancelar plano',
            description:
              err.message ||
              'Ocorreu um erro ao tentar cancelar sua assinatura. Tente novamente ou contate o suporte.',
          })
        } finally {
          setLoading(false)
        }
        break
    }
  }

  const handleConfirm = () => {
    form.submit()
  }

  const StepComponent = {
    reason: StepOne,
    password: StepTwo,
    confirmation: StepThree,
  }[step]

  useEffect(() => {
    // Reset form and step when modal is closed
    return () => {
      if (modalIsOpen) {
        form.resetFields()
        setStep('reason')
      }
    }
  }, [modalIsOpen, form])

  return (
    <AppModal
      modalId={MODAL_ID}
      width={{ md: '852px' }}
      onCancel={onCancel}
      styles={modalStyles}
      footer={
        <Footer step={step} onConfirm={handleConfirm} loading={loading} />
      }
      destroyOnHidden
      closable
    >
      <Header step={step} />

      <div className="mt-12!">
        <Form
          form={form}
          name="cancellationForm"
          layout="vertical"
          autoComplete="off"
          onFinish={onFinish}
          validateMessages={{ required: '' }}
        >
          <StepComponent />
        </Form>
      </div>
    </AppModal>
  )
})

export default CancelPlanModal
